import { siteConfig } from "~/config/site";

export function AvailabilityBadge() {
  return (
    <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-ink/10 bg-white px-3 py-2 text-xs font-bold text-ink/70 shadow-sm">
      <span className="size-2 rounded-full bg-leaf" aria-hidden />
      <span>Available in</span>
      <span className="rounded-full bg-cloud px-2 py-0.5 text-moss">
        {siteConfig.hostingLocations
          .map((location) => location.code)
          .join(" + ")}
      </span>
      <span>locations</span>
    </div>
  );
}
